import { useState } from 'react'
import PropTypes from 'prop-types'
import copy from 'copy-to-clipboard'

import DDIcon from '../../icons/DDIcon'
import styles from './CopyButton.module.css'

// Spec §5.8 — copy icon swaps to a green check for 1.6s on click; the caller is
// responsible for surfacing the "Account number copied" Toast via onCopied.
const ICON_SWAP_MS = 1600

const CopyButton = ({ text, label, onCopied }) => {
  const [copied, setCopied] = useState(false)

  const handleClick = () => {
    copy(text)
    setCopied(true)
    onCopied?.()
    setTimeout(() => setCopied(false), ICON_SWAP_MS)
  }

  return (
    <button type='button' className={styles.button} aria-label={label} onClick={handleClick}>
      <DDIcon name={copied ? 'verified-fill' : 'table-copy'} />
    </button>
  )
}

CopyButton.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onCopied: PropTypes.func,
}

export default CopyButton
